import {
    Component,
    Input,
} from '@angular/core';

/** Componente de exibição de erro. */
@Component({
    selector: 'ndd-ng-form-error',
    template: require('./ndd-ng-form-error.component.html'),
})
export class NDDFormErrorComponent {
    /** Mensagem de erro. */
    @Input() public errorMessage: string;
}
